/**
 * 智能体调度推送状态。
 */
export type AgentDispatchStatus =
  | "queued"
  | "notification_sent"
  | "sms_sent"
  | "skipped"
  | "failed";

interface AgentDispatchStatusMeta {
  title: string;
  color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
}

const AGENT_DISPATCH_STATUS_MAP: Record<AgentDispatchStatus, AgentDispatchStatusMeta> = {
  queued: {
    title: "等待推送",
    color: "warning",
  },
  notification_sent: {
    title: "已发送APP通知",
    color: "info",
  },
  sms_sent: {
    title: "已发送短信通知",
    color: "success",
  },
  skipped: {
    title: "推送跳过（超限）",
    color: "default",
  },
  failed: {
    title: "推送失败",
    color: "error",
  },
};

/**
 * 全部已知推送状态列表。
 */
export const AGENT_DISPATCH_STATUSES: AgentDispatchStatus[] = [
  "queued",
  "notification_sent",
  "sms_sent",
  "skipped",
  "failed",
];

/**
 * 判断是否为已知推送状态。
 */
export const isAgentDispatchStatus = (value: string): value is AgentDispatchStatus => {
  return Object.prototype.hasOwnProperty.call(AGENT_DISPATCH_STATUS_MAP, value);
};

/**
 * 获取推送状态中文标题。
 */
export const getAgentDispatchStatusTitle = (status: string | null | undefined): string => {
  if (!status) {
    return "-";
  }
  if (isAgentDispatchStatus(status)) {
    return AGENT_DISPATCH_STATUS_MAP[status].title;
  }
  return status;
};

/**
 * 获取推送状态 Chip 颜色。
 */
export const getAgentDispatchStatusColor = (
  status: string | null | undefined
): AgentDispatchStatusMeta["color"] => {
  if (status && isAgentDispatchStatus(status)) {
    return AGENT_DISPATCH_STATUS_MAP[status].color;
  }
  return "default";
};

/**
 * 获取状态下拉筛选项。
 */
export const getAgentDispatchStatusChoices = (): Array<{ id: AgentDispatchStatus; name: string }> => {
  return AGENT_DISPATCH_STATUSES.map((status) => ({
    id: status,
    name: AGENT_DISPATCH_STATUS_MAP[status].title,
  }));
};
